//todo: work on gif image in menu (video)


// e4383b
// 191919

const dataProjects = [
    {
        id: '1',
        postType: 'first',
        type: 'Video',
        type2: 'Live session',
        lenght: '16:39',
        title: 'TIMEA',
        subtitle: 'TIMEA',
        src: "https://player.vimeo.com/video/1016123302",
        video: '/assets/videos/timea.mp4',
        image: '/assets/images/projects/timea/_4.jpg',
        imageWidth: "1920",
        imageHeight: "1280",
        imagesCount: "97",
        info: "0",
        date: '2022-05-03',
        desc: 'Natáčanie videoklipov alebo live sessions je pre nás srdcová záležitosť. Na chvíľu sa cítite súčasťou kapely, spoznáte ich fungovanie a na krátky okamih žijete ich život. Každá kapela alebo jednotlivec prináša prostredníctvom hudby a osobnosti do videa inú energiu. Timea a jej ľahko počúvateľný pop s emotívnou atmosférou a inšpirácií z alternatívnejších žánrov stihol za krátku dobu zaujať širokú verejnosť. My sme mali možnosť live spracovať jej tri piesne v priestore s príznačným názvom Oáza v Starej Tržnici v Bratislave.',
        client: 'TIMEA',
        color: 'fff',
        client_people: [{ title: 'Vocals', person: 'Timea' },
        { title: 'Bass', person: 'Michal Šelep' },
        { title: 'Drums', person: 'Mattia Muller' },
        { title: 'Guitar', person: 'Lukáš Hlaváč' },
        { title: 'Drums', person: 'Peter Kunzo' }],

        production_people: [{ title: 'Camera one', person: 'Jakub Brehuv' },
        { title: 'Camera two', person: 'Šimon Brehuv' },
        { title: 'Edit', person: 'Šimon Brehuv' },
        { title: 'Colour grading', person: 'Jakub Brehuv' }],

        pictures: [
            '/assets/images/projects/timea/_4.jpg',
            '/assets/images/projects/timea/_10.jpg',
            '/assets/images/projects/timea/_5.jpg',
            '/assets/images/projects/timea/_1.jpg',
            '/assets/images/projects/timea/_2.jpg',
            '/assets/images/projects/timea/_3.jpg',
            '/assets/images/projects/timea/_8.jpg',
            '/assets/images/projects/timea/_9.jpg',
            '/assets/images/projects/timea/_7.jpg',
            '/assets/images/projects/timea/_11.jpg',
            '/assets/images/projects/timea/_12.jpg',
            '/assets/images/projects/timea/_13.jpg',
            '/assets/images/projects/timea/_14.jpg',
            '/assets/images/projects/timea/_15.jpg',
            '/assets/images/projects/timea/_16.jpg',
            '/assets/images/projects/timea/_17.jpg',
            '/assets/images/projects/timea/_18.jpg',
            '/assets/images/projects/timea/_19.jpg',
            '/assets/images/projects/timea/_20.jpg',
            '/assets/images/projects/timea/_21.jpg',
            '/assets/images/projects/timea/_22.jpg',
            '/assets/images/projects/timea/_6.jpg',
        ]
    },
    {
        id: '2',
        postType: '1',
        type: 'Video',
        type2: 'music clip',
        lenght: '4:19',
        title: 'Z dvoch dlaňí',
        subtitle: 'Sima Magušinová',
        src: "https://player.vimeo.com/video/1016141503",
        video: '/assets/videos/sima.mp4',
        image: '/assets/images/projects/sima/16.jpg',
        imageWidth: "1920",
        imageHeight: "1280",
        imagesCount: "97",
        info: "0",
        date: '2022-05-03',
        desc: 'Pieseň o radosti a slobode, ktorú prežívam keď veci odovzdám do Božích rúk :-)',
        client: 'Sima Magusinova',
        link: 'https://drive.google.com/drive/folders/1e4_xA2mw4z5Cte80nAqJgYp8_8q3LzD7?usp=sharing',
        color: 'fff',

        client_people: [{ title: 'Hudba, text', person: 'Sima Magušinová' },
        { title: 'Klavír', person: 'Daniel Špiner' },
        { title: 'Kontrabas', person: 'Michal Šelep' },
        { title: 'Bicie', person: 'Igor Ajdži Sabo' },
        { title: 'Aranž pre dychovú sekciu', person: ' Adrián Harvan' },
        { title: 'Dychová sekcia', person: 'Andrej Rázga, Marek Pastírik, Martin Noga' },
        { title: 'Mix, master', person: 'Randy Gnepa' },
        { title: 'Nahraté v', person: 'Melody studio' },
    ],
        production_people: [{ title: 'Camera', person: 'Jakub Brehuv' },
        { title: 'Edit', person: 'Šimon Brehuv' },
        { title: 'Colour grading', person: 'Jakub Brehuv' }],
        pictures: [
            '/assets/images/projects/sima/4.jpg',
            '/assets/images/projects/sima/10.jpg',
            '/assets/images/projects/sima/5.jpg',
            '/assets/images/projects/sima/29.jpg',
            '/assets/images/projects/sima/28.jpg',
            '/assets/images/projects/sima/2.jpg',
            '/assets/images/projects/sima/3.jpg',
            '/assets/images/projects/sima/8.jpg',
            '/assets/images/projects/sima/9.jpg',
            '/assets/images/projects/sima/7.jpg',
            '/assets/images/projects/sima/11.jpg',
            '/assets/images/projects/sima/12.jpg',
            '/assets/images/projects/sima/13.jpg',
            '/assets/images/projects/sima/14.jpg',
            '/assets/images/projects/sima/15.jpg',
            '/assets/images/projects/sima/17.jpg',
            '/assets/images/projects/sima/18.jpg',
            '/assets/images/projects/sima/19.jpg',
            '/assets/images/projects/sima/20.jpg',
            '/assets/images/projects/sima/22.jpg',
            '/assets/images/projects/sima/6.jpg',
            '/assets/images/projects/sima/24.jpg',
            '/assets/images/projects/sima/26.jpg',
            '/assets/images/projects/sima/27.jpg',

        ]
    },
    {
        id: '3',
        postType: '1',
        type: 'Video',
        type2: 'music clip',
        lenght: '3:20',
        title: 'Duše divoké',
        subtitle: 'Sima Magušinová',
        src: "https://player.vimeo.com/video/1017103928",
        video: '/assets/videos/sima2.mp4',
        image: '/assets/images/projects/sima_web/thumb.jpg',
        imageWidth: "1920",
        imageHeight: "1280",
        imagesCount: "97",
        info: "0",
        date: '2022-05-03',
        desc: 'Pieseň o jednoduchosti, nadhľade a zdravej nespútanosti, ktorá nám prináša radosť - ako odmenu:-)',
        clientHead: 'Pieseň o jednoduchosti, nadhľade a zdravej nespútanosti, ktorá nám prináša radosť - ako odmenu:-)',
        client: 'Sima Magusinova',
        link: 'https://drive.google.com/drive/folders/1e4_xA2mw4z5Cte80nAqJgYp8_8q3LzD7?usp=sharing',
        color: 'fff',
        client_people: [{ title: 'Hudba, text', person: 'Sima Magušinová' },
        { title: 'Spev, vokály', person: 'Zuzana Smatanová, Sima Magušinová' },
        { title: 'Orchester', person: 'Symfonický orchester Slovenského rozhlasu' },
        { title: 'Dirigent', person: 'Adrián Kokoš' },
        { title: 'Aranž pre orchester', person: 'Adrián Harvan' },
        { title: 'Gitara', person: 'Martin Zajko' },
        { title: 'Perkusie', person: 'Igor Ajdži Sabo' },
        { title: 'Mix, master', person: 'Basem3nt Studio (Randy Gnepa)' },
        { title: 'Nahraté v', person: 'Melody studio' }],

        production_people: [{ title: 'Camera', person: 'Jakub Brehuv' },
        { title: 'Edit', person: 'Šimon Brehuv' },
        { title: 'Colour grading', person: 'Jakub Brehuv' },
        { title: 'Kostým', person: 'Dáša Kinik' },
        { title: 'Tanec', person: 'Ivana Antolová, Natália Benková, Alžbeta Talčíková, Tereza Kmotorková' },
        { title: 'Priestor', person: ' Kollégium Antona Neuwirtha' },
        { title: 'Tanec', person: 'Ivana Antolová, Natália Benková, Alžbeta Talčíková, Tereza Kmotorková' },],
        pictures: [
            '/assets/images/projects/sima_web/_1.jpg',
            '/assets/images/projects/sima_web/_2.jpg',
            '/assets/images/projects/sima_web/_3.jpg',
            '/assets/images/projects/sima_web/_4.jpg',
            '/assets/images/projects/sima_web/_5.jpg',
            '/assets/images/projects/sima_web/_6.jpg',
            '/assets/images/projects/sima_web/_7.jpg',
            '/assets/images/projects/sima_web/_8.jpg',
            '/assets/images/projects/sima_web/_9.jpg',
            '/assets/images/projects/sima_web/_10.jpg',
            '/assets/images/projects/sima_web/_11.jpg',
            '/assets/images/projects/sima_web/_12.jpg',
            '/assets/images/projects/sima_web/_13.jpg',
            '/assets/images/projects/sima_web/_14.jpg',
        ]
    },
    {
        id: '4',
        postType: '1',
        type: 'Video',
        type2: 'music clip',
        lenght: '3:22',
        title: 'Sunflower',
        subtitle: 'Tamara Kramar',
        src: "https://player.vimeo.com/video/1017063038",
        video: '/assets/videos/tamara.mp4',
        image: '/assets/images/projects/tamara_web/_3.jpg',
        imageWidth: "1920",
        imageHeight: "1280",
        imagesCount: "97",
        info: "0",
        date: '2022-05-03',
        desc: '',
        client: 'Tamara Kramar',
        color: 'fff',
     
        client_people: [{ title: ' Written, produced and performed', person: 'Tamara Kramar' },
        { title: 'Bass', person: 'Michal Šelep' },
        { title: 'Keys', person: 'Peter Kunzo' },
        { title: 'Flute', person: 'Ruta Sipola' },
        { title: 'Drums', person: 'Nicholas Stampf' },
        { title: 'Mix', person: 'Jaro Žigo' },
        { title: 'Master', person: 'Jan Zborovjan' }],

     
        production_people: [{ title: 'Camera, Edit', person: 'Jakub Brehuv' },
        { title: 'bts/assistandst', person: 'Kaja Korim, Šimon Brehuv' }],
       
       
        pictures: [
            '/assets/images/projects/tamara_web/_2.jpg',
            '/assets/images/projects/tamara_web/_3.jpg',
            '/assets/images/projects/tamara_web/_5.jpg',
            '/assets/images/projects/tamara_web/_1.jpg',
            '/assets/images/projects/tamara_web/_4.jpg',
            '/assets/images/projects/tamara_web/_10.jpg',
            '/assets/images/projects/tamara_web/_6.jpg',
            '/assets/images/projects/tamara_web/_8.jpg',
            '/assets/images/projects/tamara_web/_9.jpg',
            '/assets/images/projects/tamara_web/_7.jpg',
            '/assets/images/projects/tamara_web/_11.jpg',
            '/assets/images/projects/tamara_web/_12.jpg',
            '/assets/images/projects/tamara_web/_13.jpg',
            '/assets/images/projects/tamara_web/_14.jpg',
            '/assets/images/projects/tamara_web/_15.jpg',
            '/assets/images/projects/tamara_web/_16.jpg',
            '/assets/images/projects/tamara_web/_17.jpg',
            '/assets/images/projects/tamara_web/_18.jpg',
            '/assets/images/projects/tamara_web/_19.jpg',
            '/assets/images/projects/tamara_web/_20.jpg',
            '/assets/images/projects/tamara_web/_21.jpg',
            '/assets/images/projects/tamara_web/_22.jpg',
        ]
    },
    {
        id: '5',
        postType: '1',
        type: 'Video',
        type2: 'music clip',
        lenght: '3:39',
        title: 'vlny bozky ',
        subtitle: 'Rijola',
        src: "https://player.vimeo.com/video/1017670681",
        video: '/assets/videos/rijola.mp4',
        image: '/assets/images/projects/rijola/_1.jpg',
        imageWidth: "1920",
        imageHeight: "1280",
        imagesCount: "97",
        info: "0",
        date: '2022-05-03',
        desc: '',
        client: 'Rijola',
        color: 'fff',
     
        // client_people: [{ title: ' Written, produced and performed', person: 'Tamara Kramar' },
        // { title: 'Bass', person: 'Michal Šelep' },
        // { title: 'Keys', person: 'Peter Kunzo' },
        // { title: 'Flute', person: 'Ruta Sipola' },
        // { title: 'Drums', person: 'Nicholas Stampf' },
        // { title: 'Mix', person: 'Jaro Žigo' },
        // { title: 'Master', person: 'Jan Zborovjan' }],
        client_people: [{ title: 'Bicie', person: 'David Motyl' },
            { title: 'Spev', person: 'Andrej Velebir' }
          ],

     
        production_people: [{ title: 'Director', person: 'Šimon Brehuv' },
            { title: 'Camera', person: 'Jakub Brehuv' },
            { title: 'Edit', person: 'Šimon Brehuv' },
            { title: 'Colour grading', person: 'Jakub Brehuv' }],
       
       
        pictures: [
            '/assets/images/projects/rijola/_3.jpg',
            '/assets/images/projects/rijola/_4.jpg',
            '/assets/images/projects/rijola/_5.jpg',
            '/assets/images/projects/rijola/_6.jpg',
            '/assets/images/projects/rijola/_7.jpg',
            '/assets/images/projects/rijola/_8.jpg',
            '/assets/images/projects/rijola/_9.jpg',
            '/assets/images/projects/rijola/_10.jpg',
            '/assets/images/projects/rijola/_11.jpg',
            '/assets/images/projects/rijola/_12.jpg',
            '/assets/images/projects/rijola/_13.jpg',
            '/assets/images/projects/rijola/_14.jpg',
            '/assets/images/projects/rijola/_15.jpg',
            '/assets/images/projects/rijola/_16.jpg',
            '/assets/images/projects/rijola/_17.jpg',
            '/assets/images/projects/rijola/_18.jpg',
            '/assets/images/projects/rijola/_19.jpg',
            '/assets/images/projects/rijola/_20.jpg',
            '/assets/images/projects/rijola/_1.jpg',
            '/assets/images/projects/rijola/_2.jpg',


   
        ]
    },
    {
        id: '6',
        postType: '1',
        type: 'Video',
        type2: 'ad',
        lenght: '1:10',
        title: 'PESŤAHUJME SPOLU WAVE CNK',
        subtitle: 'WAVE',
        src: "https://player.vimeo.com/video/1018195989",
        video: '/assets/videos/wave.mp4',
        image: '/assets/images/projects/wave/_10.jpg',
        imageWidth: "1920",
        imageHeight: "1280",
        imagesCount: "97",
        info: "0",
        date: '2022-05-03',
        desc: '',
        client: 'WAVE',
        color: 'fff',
     
        // client_people: [{ title: ' Written, produced and performed', person: 'Tamara Kramar' },
        // { title: 'Bass', person: 'Michal Šelep' },
        // { title: 'Keys', person: 'Peter Kunzo' },
        // { title: 'Flute', person: 'Ruta Sipola' },
        // { title: 'Drums', person: 'Nicholas Stampf' },
        // { title: 'Mix', person: 'Jaro Žigo' },
        // { title: 'Master', person: 'Jan Zborovjan' }],
        client_people: [
          ],

     
          production_people: [{ title: 'Director', person: 'Alex Gburova' },
            { title: 'Camera, Edit, Colour grading', person: 'Jakub Brehuv' },
            { title: 'Sound', person: 'Šimon Brehuv' }],
       
       
        pictures: [
            '/assets/images/projects/wave/_1.jpg',
            '/assets/images/projects/wave/_2.jpg',
            '/assets/images/projects/wave/_3.jpg',
            '/assets/images/projects/wave/_4.jpg',
            '/assets/images/projects/wave/_5.jpg',
            '/assets/images/projects/wave/_6.jpg',
            '/assets/images/projects/wave/_7.jpg',
            '/assets/images/projects/wave/_8.jpg',
            '/assets/images/projects/wave/_9.jpg',
            '/assets/images/projects/wave/_10.jpg',
        ]
    },
    {
        id: '7',
        postType: '1',
        type: 'Video',
        type2: 'music clip',
        lenght: '5:30',
        title: 'Samota - Havrilla',
        subtitle: 'Havrilla',
        src: "https://player.vimeo.com/video/1037428803",
        video: '/assets/videos/dusan_bezis.mp4',
        image: '/assets/images/projects/dusan_bezis/thumb.jpg',
        imageWidth: "1920",
        imageHeight: "1280",
        imagesCount: "4",
        info: "0",
        date: '2022-05-03',
        desc: '',
        client: 'Havrilla',
        color: 'fff',
     
        // client_people: [{ title: ' Written, produced and performed', person: 'Tamara Kramar' },
        // { title: 'Bass', person: 'Michal Šelep' },
        // { title: 'Keys', person: 'Peter Kunzo' },
        // { title: 'Flute', person: 'Ruta Sipola' },
        // { title: 'Drums', person: 'Nicholas Stampf' },
        // { title: 'Mix', person: 'Jaro Žigo' },
        // { title: 'Master', person: 'Jan Zborovjan' }],
        client_people: [
          ],

     
          production_people: [
            { title: 'Camera, Edit, Colour grading', person: 'Jakub Brehuv' },
            { title: 'Sound', person: 'Beyond Music Studio' }],
       
       
        pictures: [
            '/assets/images/projects/dusan_bezis/_1.jpg',
            '/assets/images/projects/dusan_bezis/_2.jpg',
            '/assets/images/projects/dusan_bezis/_3.jpg',
            '/assets/images/projects/dusan_bezis/_4.jpg',
        ]
    },
    {
        id: '8',
        postType: '1',
        type: 'Video',
        type2: 'live session',
        lenght: '13:21',
        title: 'havrilla - live at Beyond Music Studio',
        subtitle: 'havrilla',
        src: "https://player.vimeo.com/video/1026509544",
        video: '/assets/videos/dusan_sesh.mp4',
        image: '/assets/images/projects/dusan_sesh/a_9.1.2.jpg',
        imageWidth: "1920",
        imageHeight: "1280",
        imagesCount: "9",
        info: "0",
        date: '2022-05-03',
        desc: '',
        client: 'havrilla',
        color: 'fff',
     
        // client_people: [{ title: ' Written, produced and performed', person: 'Tamara Kramar' },
        // { title: 'Bass', person: 'Michal Šelep' },
        // { title: 'Keys', person: 'Peter Kunzo' },
        // { title: 'Flute', person: 'Ruta Sipola' },
        // { title: 'Drums', person: 'Nicholas Stampf' },
        // { title: 'Mix', person: 'Jaro Žigo' },
        // { title: 'Master', person: 'Jan Zborovjan' }],
        client_people: [
          ],

     
          production_people: [{ title: 'Camera', person: 'Jakub Brehuv' },
            { title: 'Camera, Edit, Colour grading', person: 'Jakub Brehuv' }],
       
       
        pictures: [
            '/assets/images/projects/dusan_sesh/a_9.1.2.jpg',
            '/assets/images/projects/dusan_sesh/a_9.1.4.jpg',
            '/assets/images/projects/dusan_sesh/a_9.1.7.jpg',
            '/assets/images/projects/dusan_sesh/a_9.1.8.jpg',
            '/assets/images/projects/dusan_sesh/a_9.1.9.jpg',
            '/assets/images/projects/dusan_sesh/a_9.1.16.jpg',
            '/assets/images/projects/dusan_sesh/a_9.1.17.jpg',
            '/assets/images/projects/dusan_sesh/a_9.1.18.jpg',
            '/assets/images/projects/dusan_sesh/a_9.1.21.jpg',
        ]
    },
      {
        id: '9',
        postType: '1',
        type: 'Video',
        type2: 'music video',
        lenght: '3:10',
        title: 'Meowlau X Val - kidZ',
        subtitle: 'Meowlau X Val',
        src: "https://player.vimeo.com/video/1023880306",
        video: '/assets/videos/mxv.mp4',
        image: '/assets/images/projects/mxw_kidz/thumb.jpg',
        imageWidth: "1920",
        imageHeight: "1280",
        imagesCount: "9",
        info: "0",
        date: '2022-05-03',
        desc: '',
        client: 'MxV',
        color: 'fff',
     
        // client_people: [{ title: ' Written, produced and performed', person: 'Tamara Kramar' },
        // { title: 'Bass', person: 'Michal Šelep' },
        // { title: 'Keys', person: 'Peter Kunzo' },
        // { title: 'Flute', person: 'Ruta Sipola' },
        // { title: 'Drums', person: 'Nicholas Stampf' },
        // { title: 'Mix', person: 'Jaro Žigo' },
        // { title: 'Master', person: 'Jan Zborovjan' }],
        client_people: [
          ],

     
     production_people: [{ title: 'Camera', person: 'Jakub Brehuv' },
            { title: ' Edit, Colour grading', person: 'Jakub Brehuv' }],
       
       
        pictures: [
            '/assets/images/projects/mxw_kidz/_1.jpg',
            '/assets/images/projects/mxw_kidz/_2.jpg',
            '/assets/images/projects/mxw_kidz/_3.jpg',
            '/assets/images/projects/mxw_kidz/_4.jpg',
            '/assets/images/projects/mxw_kidz/_5.jpg',
            '/assets/images/projects/mxw_kidz/_6.jpg',
            '/assets/images/projects/mxw_kidz/_9.jpg',
            '/assets/images/projects/mxw_kidz/_10.jpg',

                        '/assets/images/projects/mxw_kidz/_11.jpg',
            '/assets/images/projects/mxw_kidz/_12.jpg',
            '/assets/images/projects/mxw_kidz/_13.jpg',
            '/assets/images/projects/mxw_kidz/_14.jpg',
            '/assets/images/projects/mxw_kidz/_15.jpg',
            '/assets/images/projects/mxw_kidz/_16.jpg',
            '/assets/images/projects/mxw_kidz/_17.jpg',
            '/assets/images/projects/mxw_kidz/_18.jpg',
            '/assets/images/projects/mxw_kidz/_19.jpg',
            '/assets/images/projects/mxw_kidz/_20.jpg',

                        '/assets/images/projects/mxw_kidz/_21.jpg',
            '/assets/images/projects/mxw_kidz/_22.jpg',
            '/assets/images/projects/mxw_kidz/_23.jpg',
            '/assets/images/projects/mxw_kidz/_24.jpg',
            '/assets/images/projects/mxw_kidz/_25.jpg',
            '/assets/images/projects/mxw_kidz/_26.jpg',
            '/assets/images/projects/mxw_kidz/_27.jpg',
            '/assets/images/projects/mxw_kidz/_28.jpg',
            '/assets/images/projects/mxw_kidz/_29.jpg',
            '/assets/images/projects/mxw_kidz/_30.jpg',

                        '/assets/images/projects/mxw_kidz/_31.jpg',
            '/assets/images/projects/mxw_kidz/_32.jpg',
            '/assets/images/projects/mxw_kidz/_33.jpg',
            '/assets/images/projects/mxw_kidz/_34.jpg',
            '/assets/images/projects/mxw_kidz/_35.jpg',
            '/assets/images/projects/mxw_kidz/_36.jpg',
            '/assets/images/projects/mxw_kidz/_37.jpg',
            '/assets/images/projects/mxw_kidz/_38.jpg',
            '/assets/images/projects/mxw_kidz/_39.jpg',
            '/assets/images/projects/mxw_kidz/_30.jpg',

                        '/assets/images/projects/mxw_kidz/_41.jpg',
            '/assets/images/projects/mxw_kidz/_42.jpg',
            '/assets/images/projects/mxw_kidz/_43.jpg',
            '/assets/images/projects/mxw_kidz/_44.jpg',
         
        ]
    },
      {
        id: '10',
        postType: '1',
        type: 'Video',
        type2: 'live session',
        lenght: '',
        title: 'Meowlau X Val - DAYDREAM',
        subtitle: 'Meowlau X Val',
        src: "https://player.vimeo.com/video/1026506143",
        video: '/assets/videos/mxv_sesh.mp4',
        image: '/assets/images/projects/mxv_sesh/thumb.jpg',
        imageWidth: "1920",
        imageHeight: "1280",
        imagesCount: "9",
        info: "0",
        date: '2022-05-03',
        desc: '',
        client: 'MxV',
        color: 'fff',
     
        // client_people: [{ title: ' Written, produced and performed', person: 'Tamara Kramar' },
        // { title: 'Bass', person: 'Michal Šelep' },
        // { title: 'Keys', person: 'Peter Kunzo' },
        // { title: 'Flute', person: 'Ruta Sipola' },
        // { title: 'Drums', person: 'Nicholas Stampf' },
        // { title: 'Mix', person: 'Jaro Žigo' },
        // { title: 'Master', person: 'Jan Zborovjan' }],
        client_people: [
          ],

     
          production_people: [{ title: 'Camera', person: 'Jakub Brehuv, Simon Brehuv' },
            { title: 'Edit', person: 'Šimon Brehuv' },
        { title: 'Colour grading', person: 'Jakub Brehuv' }],
       
       
        pictures: [
            '/assets/images/projects/mxv_sesh/_1.jpg',
            '/assets/images/projects/mxv_sesh/_2.jpg',
            '/assets/images/projects/mxv_sesh/_3.jpg',
            '/assets/images/projects/mxv_sesh/_4.jpg',
            '/assets/images/projects/mxv_sesh/_5.jpg',
            '/assets/images/projects/mxv_sesh/_7.jpg',
            '/assets/images/projects/mxv_sesh/_8.jpg',
            '/assets/images/projects/mxv_sesh/_9.jpg',
            '/assets/images/projects/mxv_sesh/_10.jpg',
            '/assets/images/projects/mxv_sesh/_11.jpg',
            '/assets/images/projects/mxv_sesh/_12.jpg',
            '/assets/images/projects/mxv_sesh/_13.jpg',
            '/assets/images/projects/mxv_sesh/_14.jpg',
            '/assets/images/projects/mxv_sesh/_15.jpg',
            '/assets/images/projects/mxv_sesh/_16.jpg',
            '/assets/images/projects/mxv_sesh/_17.jpg',
            '/assets/images/projects/mxv_sesh/_18.jpg',
            '/assets/images/projects/mxv_sesh/_19.jpg',
            '/assets/images/projects/mxv_sesh/_20.jpg',
            '/assets/images/projects/mxv_sesh/_21.jpg',
            '/assets/images/projects/mxv_sesh/_22.jpg',
            '/assets/images/projects/mxv_sesh/_23.jpg',
            '/assets/images/projects/mxv_sesh/_24.jpg',
            '/assets/images/projects/mxv_sesh/_25.jpg',
            '/assets/images/projects/mxv_sesh/_26.jpg',
            '/assets/images/projects/mxv_sesh/_27.jpg',
            '/assets/images/projects/mxv_sesh/_28.jpg',
            '/assets/images/projects/mxv_sesh/_29.jpg',
            '/assets/images/projects/mxv_sesh/_30.jpg',
            '/assets/images/projects/mxv_sesh/_31.jpg',
        ]
    },

       {
        id: '11',
        postType: '1',
        type: 'Video',
        type2: 'music video',
        lenght: '5:12',
        title: 'Vezmi ma domov',
        subtitle: 'Katka Koscova',
        src: "https://player.vimeo.com/video/1122928118",
        video: '/assets/videos/koscova.mp4',
        image: '/assets/images/projects/koscova/thumb.jpg',
        imageWidth: "1920",
        imageHeight: "1280",
        imagesCount: "9",
        info: "0",
        date: '2022-05-03',
        desc: '',
        client: 'Katka Koscova',
        color: 'fff',
     
        // client_people: [{ title: ' Written, produced and performed', person: 'Tamara Kramar' },
        // { title: 'Bass', person: 'Michal Šelep' },
        // { title: 'Keys', person: 'Peter Kunzo' },
        // { title: 'Flute', person: 'Ruta Sipola' },
        // { title: 'Drums', person: 'Nicholas Stampf' },
        // { title: 'Mix', person: 'Jaro Žigo' },
        // { title: 'Master', person: 'Jan Zborovjan' }],
        client_people: [
          ],

     
            production_people: [
            { title: 'Camera', person: 'Jakub Brehuv' },
            { title: 'Edit', person: 'Jakub Brehuv' }],
       
       
        pictures: [
            '/assets/images/projects/koscova/_1.jpg',
            '/assets/images/projects/koscova/_3.jpg',
            '/assets/images/projects/koscova/_4.jpg',
            '/assets/images/projects/koscova/_5.jpg',
            '/assets/images/projects/koscova/_6.jpg',
            '/assets/images/projects/koscova/_7.jpg',
            '/assets/images/projects/koscova/_8.jpg',
            '/assets/images/projects/koscova/_9.jpg',
            '/assets/images/projects/koscova/_10.jpg',
            '/assets/images/projects/koscova/_11.jpg',
            '/assets/images/projects/koscova/_12.jpg',
            '/assets/images/projects/koscova/_13.jpg',
            '/assets/images/projects/koscova/_14.jpg',
            '/assets/images/projects/koscova/_15.jpg',
            '/assets/images/projects/koscova/_16.jpg',
            '/assets/images/projects/koscova/_17.jpg',
            '/assets/images/projects/koscova/_18.jpg',
            '/assets/images/projects/koscova/_19.jpg',
            '/assets/images/projects/koscova/_20.jpg',
            '/assets/images/projects/koscova/_21.jpg',
            '/assets/images/projects/koscova/_22.jpg',
            '/assets/images/projects/koscova/_23.jpg',
            '/assets/images/projects/koscova/_24.jpg',
            '/assets/images/projects/koscova/_25.jpg',
            '/assets/images/projects/koscova/_26.jpg',
            '/assets/images/projects/koscova/_27.jpg',
        ] 
    },
   






      {
        id: '12',
        postType: '1',
        type: 'Video',
        type2: 'video session',
        lenght: '12:48',
        title: 'Papyllon – LIVE IN MUSEUM',
        subtitle: 'Papyllon',
        src: "https://player.vimeo.com/video/1026472907",
        video: '/assets/videos/papyllon_sesh1.mp4',
        image: '/assets/images/projects/papyllon_sesh1/thumb.jpg',
        imageWidth: "1920",
        imageHeight: "1280",
        imagesCount: "9",
        info: "0",
        date: '2022-05-03',
        desc: '',
        client: 'Papyllon',
        color: 'fff',
     
        // client_people: [{ title: ' Written, produced and performed', person: 'Tamara Kramar' },
        // { title: 'Bass', person: 'Michal Šelep' },
        // { title: 'Keys', person: 'Peter Kunzo' },
        // { title: 'Flute', person: 'Ruta Sipola' },
        // { title: 'Drums', person: 'Nicholas Stampf' },
        // { title: 'Mix', person: 'Jaro Žigo' },
        // { title: 'Master', person: 'Jan Zborovjan' }],
        client_people: [
          ],

     
          production_people: [
            { title: 'Camera', person: 'Jakub Brehuv, Šimon Brehuv, Marko Gerboc' },
            { title: 'Edit, Colour grading', person: 'Jakub Brehuv' },
            { title: 'Sound', person: 'Richard Rác' }],
       
       
        pictures: [
            '/assets/images/projects/papyllon_sesh1/_1.jpg',
            '/assets/images/projects/papyllon_sesh1/_2.jpg',
            '/assets/images/projects/papyllon_sesh1/_3.jpg',
            '/assets/images/projects/papyllon_sesh1/_4.jpg',
            '/assets/images/projects/papyllon_sesh1/_5.jpg',
            '/assets/images/projects/papyllon_sesh1/_6.jpg',
            '/assets/images/projects/papyllon_sesh1/_7.jpg',
            '/assets/images/projects/papyllon_sesh1/_8.jpg',
            '/assets/images/projects/papyllon_sesh1/_9.jpg',
            '/assets/images/projects/papyllon_sesh1/_10.jpg',
            '/assets/images/projects/papyllon_sesh1/_11.jpg',
            '/assets/images/projects/papyllon_sesh1/_12.jpg',
            '/assets/images/projects/papyllon_sesh1/_13.jpg',
            '/assets/images/projects/papyllon_sesh1/_14.jpg',
            '/assets/images/projects/papyllon_sesh1/_15.jpg',
            '/assets/images/projects/papyllon_sesh1/_16.jpg',
            '/assets/images/projects/papyllon_sesh1/_17.jpg',
            '/assets/images/projects/papyllon_sesh1/_18.jpg',
            '/assets/images/projects/papyllon_sesh1/_19.jpg',
            '/assets/images/projects/papyllon_sesh1/_20.jpg',
            '/assets/images/projects/papyllon_sesh1/_21.jpg',
            '/assets/images/projects/papyllon_sesh1/_22.jpg',
            '/assets/images/projects/papyllon_sesh1/_23.jpg',
            '/assets/images/projects/papyllon_sesh1/_24.jpg',
                        
         ]
    },
      {
        id: '13',
        postType: '1',
        type: 'Video',
        type2: 'video session',
        lenght: '9:59',
        title: 'Papyllon - SHELTER SESSION 2',
        subtitle: 'Papyllon',
        src: "https://player.vimeo.com/video/1026506049",
        video: '/assets/videos/papyllon_sesh2.mp4',
        image: '/assets/images/projects/papyllon_sesh2/thumb.jpg',
        imageWidth: "1920",
        imageHeight: "1280",
        imagesCount: "9",
        info: "0",
        date: '2022-05-03',
        desc: '',
        client: 'Papyllon',
        color: 'fff',
     
        // client_people: [{ title: ' Written, produced and performed', person: 'Tamara Kramar' },
        // { title: 'Bass', person: 'Michal Šelep' },
        // { title: 'Keys', person: 'Peter Kunzo' },
        // { title: 'Flute', person: 'Ruta Sipola' },
        // { title: 'Drums', person: 'Nicholas Stampf' },
        // { title: 'Mix', person: 'Jaro Žigo' },
        // { title: 'Master', person: 'Jan Zborovjan' }],
        client_people: [
          ],

     
             production_people: [
            { title: 'Camera', person: 'Jakub Brehuv, Šimon Brehuv' },
            { title: 'Edit, Colour grading', person: 'Jakub Brehuv' },
            { title: 'Sound', person: 'Richard Rác' }],
       
       
        pictures: [
            '/assets/images/projects/papyllon_sesh2/_1.jpg',
            '/assets/images/projects/papyllon_sesh2/_2.jpg',
            '/assets/images/projects/papyllon_sesh2/_3.jpg',
            '/assets/images/projects/papyllon_sesh2/_4.jpg',
            '/assets/images/projects/papyllon_sesh2/_5.jpg',
            '/assets/images/projects/papyllon_sesh2/_6.jpg',
            '/assets/images/projects/papyllon_sesh2/_7.jpg',
            '/assets/images/projects/papyllon_sesh2/_8.jpg',
            '/assets/images/projects/papyllon_sesh2/_9.jpg',
            '/assets/images/projects/papyllon_sesh2/_10.jpg',
            '/assets/images/projects/papyllon_sesh2/_11.jpg',
            '/assets/images/projects/papyllon_sesh2/_12.jpg',
            '/assets/images/projects/papyllon_sesh2/_13.jpg',
            '/assets/images/projects/papyllon_sesh2/_14.jpg',
            '/assets/images/projects/papyllon_sesh2/_15.jpg',
            '/assets/images/projects/papyllon_sesh2/_16.jpg',
            '/assets/images/projects/papyllon_sesh2/_17.jpg',
            '/assets/images/projects/papyllon_sesh2/_18.jpg',
            '/assets/images/projects/papyllon_sesh2/_19.jpg',
            '/assets/images/projects/papyllon_sesh2/_20.jpg',
            '/assets/images/projects/papyllon_sesh2/_21.jpg',
            '/assets/images/projects/papyllon_sesh2/_22.jpg',
            '/assets/images/projects/papyllon_sesh2/_23.jpg',
            '/assets/images/projects/papyllon_sesh2/_24.jpg',
            '/assets/images/projects/papyllon_sesh2/_25.jpg',
            '/assets/images/projects/papyllon_sesh2/_26.jpg',
            '/assets/images/projects/papyllon_sesh2/_27.jpg',
            '/assets/images/projects/papyllon_sesh2/_28.jpg',
        ]
    },





      {
        id: '14',
        postType: '1',
        type: 'Video',
        type2: 'comercial',
        lenght: '0:46',
        title: 'KAŽDÝ MÁ SEN - DEPAUL SLOVENSKO',
        subtitle: 'DEPAUL',
        src: "https://player.vimeo.com/video/1146653960",
        video: '/assets/videos/depaul.mp4',
        image: '/assets/images/projects/depaul/thumb.jpg',
        imageWidth: "1920",
        imageHeight: "1280",
        imagesCount: "9",
        info: "0",
        date: '2026-02-12',
        desc: '',
        client: 'DEPAUL',
        color: 'fff',
     
        // client_people: [{ title: ' Written, produced and performed', person: 'Tamara Kramar' },
        // { title: 'Bass', person: 'Michal Šelep' },
        // { title: 'Keys', person: 'Peter Kunzo' },
        // { title: 'Flute', person: 'Ruta Sipola' },
        // { title: 'Drums', person: 'Nicholas Stampf' },
        // { title: 'Mix', person: 'Jaro Žigo' },
        // { title: 'Master', person: 'Jan Zborovjan' }],
        client_people: [
          ],

     
             production_people: [
            { title: 'Camera, Edit, Colour grading', person: 'Jakub Brehuv' },
            { title: 'Dir', person: 'Barbora Kitko, Jakub Čaprnka' },
            { title: 'Dramaturgia', person: 'Barbora Kitko, DOminika' },
            { title: 'Rental', person: 'Mato Zednicek' },
            { title: 'Voiceover', person: 'Nora Ibsenova' },
            { title: 'Idea', person: '2create, Depaul Slovensko' }],
       
       
        pictures: [
            '/assets/images/projects/depaul/_1.gif',
        
        ]
    },

      {
        id: '15',
        postType: '1',
        type: 'Video',
        type2: 'comercial',
        lenght: '01:09',
        title: 'Bufet v Kine Úsmev',
        subtitle: 'Úsmev Bufet',
        src: "https://player.vimeo.com/video/1155544433",
        video: '/assets/videos/usmev.mp4',
        image: '/assets/images/projects/usmev/thumb.jpg',
        imageWidth: "1920",
        imageHeight: "1280",
        imagesCount: "25",
        info: "0",
        date: '2026-02-12',
        desc: '',
        client: 'Úsmev Bufet',
        color: 'fff',
     
        // client_people: [{ title: ' Written, produced and performed', person: 'Tamara Kramar' },
        // { title: 'Bass', person: 'Michal Šelep' },
        // { title: 'Keys', person: 'Peter Kunzo' },
        // { title: 'Flute', person: 'Ruta Sipola' },
        // { title: 'Drums', person: 'Nicholas Stampf' },
        // { title: 'Mix', person: 'Jaro Žigo' },
        // { title: 'Master', person: 'Jan Zborovjan' }],
        client_people: [
          ],

     
             production_people: [
            { title: 'Dir', person: 'Matúš Chovanec' },
            { title: 'Camera, Colour grading', person: 'Jakub Brehuv' },
            { title: 'Edit, Sound', person: 'Šimon Brehuv' },
            { title: 'Gaffer, 1AC', person: 'Marek Celec' }],
       
       
        pictures: [
            '/assets/images/projects/usmev/_1.jpg',
            '/assets/images/projects/usmev/_2.jpg',
            '/assets/images/projects/usmev/_3.jpg',
            '/assets/images/projects/usmev/_4.jpg',
            '/assets/images/projects/usmev/_5.jpg',
            '/assets/images/projects/usmev/_6.jpg',
            '/assets/images/projects/usmev/_7.jpg',
            '/assets/images/projects/usmev/_8.jpg',
            '/assets/images/projects/usmev/_9.jpg',
            '/assets/images/projects/usmev/_10.jpg',
            '/assets/images/projects/usmev/_11.jpg',
            '/assets/images/projects/usmev/_12.jpg',
            '/assets/images/projects/usmev/_13.jpg',
            '/assets/images/projects/usmev/_14.jpg',
            '/assets/images/projects/usmev/_15.jpg',
            '/assets/images/projects/usmev/_16.jpg',
            '/assets/images/projects/usmev/_17.jpg',
            '/assets/images/projects/usmev/_18.jpg',
            '/assets/images/projects/usmev/_19.jpg',
            '/assets/images/projects/usmev/_20.jpg',
            '/assets/images/projects/usmev/_21.jpg',
            '/assets/images/projects/usmev/_22.jpg',
            '/assets/images/projects/usmev/_23.jpg',
            '/assets/images/projects/usmev/_24.jpg',
            '/assets/images/projects/usmev/_25.jpg',
        ]
    },

    //  {
    //     id: '14',
    //     postType: '1',
    //     type: 'Video',
    //     type2: 'music video',
    //     lenght: '2:07',
    //     title: 'Owithg - ROAST',
    //     subtitle: 'Owithg',
    //     src: "https://player.vimeo.com/video/1026441388",
    //     video: '/assets/videos/roast.mp4',
    //     image: '/assets/images/projects/roast/thumb.jpg',
    //     imageWidth: "1920",
    //     imageHeight: "1280",
    //     imagesCount: "9",
    //     info: "0",
    //     date: '2022-05-03',
    //     desc: '',
    //     client: 'Owithg',
    //     color: 'fff',
     
    //     // client_people: [{ title: ' Written, produced and performed', person: 'Tamara Kramar' },
    //     // { title: 'Bass', person: 'Michal Šelep' },
    //     // { title: 'Keys', person: 'Peter Kunzo' },
    //     // { title: 'Flute', person: 'Ruta Sipola' },
    //     // { title: 'Drums', person: 'Nicholas Stampf' },
    //     // { title: 'Mix', person: 'Jaro Žigo' },
    //     // { title: 'Master', person: 'Jan Zborovjan' }],
    //     client_people: [
    //       ],

     
    //       production_people: [{ title: 'Director', person: 'Jakub Brehuv' },
    //         { title: 'Camera, Edit, Colour grading', person: 'Jakub Brehuv' },
    //         { title: 'Assistant on set', person: 'Teo Tvarožek' }],
       
       
    //     pictures: [
    //         '/assets/images/projects/papyllon_sesh2/a_9.1.2.jpg',
    //     ]
    // },
];



export default dataProjects;